// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "button[data-v-349cadb3]{color:#d3d3d3;cursor:not-allowed}", "",{"version":3,"sources":["webpack://./resources/js/Pages/Team/Settings/Billing.vue"],"names":[],"mappings":"AAEA,wBACI,aAAA,CACA,kBAAA","sourcesContent":["\n// #RPT: remove when buttons are connected\nbutton {\n    color: lightgray;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
